{
  "name": "nova",
  "version": "4.172.0",
  "private": true,
  "workspaces": [
    "apps/*",
    "libs/*"
  ],
  "scripts": {
    "prepare": "node .husky/install.mjs",
    "start": "npm run install-deps && npm run serve:infra && npm run apps:dev",
    "clean": "rimraf -g ./*/**/node_modules **/dist ./logs",
    "check-package-lock-drift": "sh ./tools/check-package-lock-drift.sh",
    "install-deps": "sh ./tools/install-deps.sh",
    "mocks": "sh ./tools/run-host-mocks.sh",
    "playwright": "cd e2e && bun playwright",
    "serve:infra": "docker compose up --profile mocks -d",
    "serve:infra:kibana": "docker compose up --profile kibana -d",
    "serve:neutron:dev": "npm run neutron:run-migrations && npm run apps:neutron:dev",
    "apps:dev": "node tools/run-workspaces-parallel.mjs dev --kill-others",
    "apps:helios:dev": "npm run dev -w @nova/helios",
    "apps:luna:dev": "npm run dev -w @nova/luna",
    "apps:photon:dev": "npm run dev -w @nova/photon",
    "apps:comet:dev": "npm run dev -w @nova/comet",
    "apps:circe:dev": "npm run dev -w @nova/circe",
    "apps:juno:dev": "npm run dev -w @nova/juno",
    "apps:neutron:dev": "NEUTRON_NO_SWAGGER=true nest start neutron --watch --debug",
    "neutron:dev:fatOrg": "make neutron.fat_org",
    "neutron:build": "rimraf dist/apps/neutron dist/neutron dist/assets && nest build neutron",
    "consumers:build": "npm run consumers:webhooks:build && npm run consumers:document-sign:build && npm run consumers:unit-limiter:build",
    "consumers:webhooks:build": "nest build webhook",
    "consumers:document-sign:build": "nest build document-sign",
    "consumers:unit-limiter:build": "nest build unit-limiter",
    "consumers:webhooks:dev": "nest start webhook --watch",
    "consumers:document-sign:dev": "nest start document-sign --watch",
    "consumers:unit-limiter:dev": "nest start unit-limiter --watch",
    "db-events-producer:build": "nest build db-events-producer",
    "db-events-producer:dev": "nest start db-events-producer --watch",
    "neutron:repl": "NEUTRON_NO_SWAGGER=true nest start neutron:repl --watch --debug",
    "neutron:dev:bun": "./tools/neutron-bun.sh dev",
    "neutron:repl:bun": "./tools/neutron-bun.sh repl",
    "lint": "node tools/oxlint-baseline/index.mjs check",
    "lint:fix": "npm run lint -- --fix",
    "format:check": "oxfmt --check",
    "format": "oxfmt --write",
    "neutron:typeorm": "./tools/typeorm.sh",
    "neutron:typeorm-no-datasource": "./tools/typeorm.sh --no-dataSource",
    "neutron:run-migrations": "./tools/neutron-bun.sh migrate",
    "neutron:run-migrations-fake": "npm run neutron:typeorm -- migration:run --fake",
    "neutron:rollback-migrations": "npm run neutron:typeorm -- migration:revert",
    "neutron:check-schema-drift": "bun ./tools/check-neutron-schema-drift.mjs",
    "neutron:generate-triggers": "bun apps/neutron/src/db_migrations/scripts/generate-triggers.ts",
    "neutron:healthcheck": "./tools/neutron-build-healthcheck.sh",
    "neutron:cronjobs:purgeElasticsearchControlTables": "./tools/neutron-bun.sh cli cronjobs purgeElasticsearchControlTables",
    "neutron:cronjobs:updateMessageDeliveryStatus": "./tools/neutron-bun.sh cli cronjobs updateMessageDeliveryStatus",
    "neutron:cronjobs:rebuildTranslationCache": "./tools/neutron-bun.sh cli cronjobs rebuildTranslationCache",
    "neutron:cronjobs:cleanupIdValidationData": "./tools/neutron-bun.sh cli cronjobs cleanupIdValidationData",
    "neutron:commands:appointmentElasticsearchBackfill": "./tools/neutron-bun.sh cli appointmentElasticsearchBackfill",
    "neutron:commands:backfillScheduleHistory": "./tools/neutron-bun.sh cli backfillScheduleHistory",
    "neutron:commands:backfillScheduleHistoryFix": "./tools/neutron-bun.sh cli backfillScheduleHistoryFix",
    "neutron:commands:redactAuditLogUserInsertPasswords": "./tools/neutron-bun.sh cli redactAuditLogUserInsertPasswords",
    "neutron:commands:countUnitLimitConfiguration": "./tools/neutron-bun.sh cli countUnitLimitConfiguration",
    "neutron:commands:installCustomFormsFeature": "./tools/neutron-bun.sh cli installCustomFormsFeature",
    "neutron:commands:migrateElasticsearch": "./tools/neutron-bun.sh cli migrateElasticsearch",
    "neutron:commands:mergeCompanies": "./tools/neutron-bun.sh cli mergeCompanies",
    "neutron:commands:revertMergedCompanies": "./tools/neutron-bun.sh cli revertMergedCompanies",
    "neutron:commands:populateCarrierContacts": "./tools/neutron-bun.sh cli populateCarrierContacts",
    "neutron:commands:populateElasticsearchIndexes": "./tools/neutron-bun.sh cli populateElasticsearchIndexes",
    "neutron:commands:semanticLabels": "./tools/neutron-bun.sh cli semanticLabels",
    "neutron:commands:updateCustomFormsName": "./tools/neutron-bun.sh cli UpdateCustomFormsName",
    "neutron:commands:reprocessIdValidationData": "./tools/neutron-bun.sh cli reprocessIdValidationData",
    "neutron:commands:backfillCompanyIdentifiers": "./tools/neutron-bun.sh cli backfillCompanyIdentifiers",
    "neutron:commands:enrichCarriers": "./tools/neutron-bun.sh cli enrichCarriers",
    "neutron:commands:backfillVehicleObservationSearchText": "./tools/neutron-bun.sh cli backfillVehicleObservationSearchText",
    "neutron:commands:fixRecurringTimezoneDrift": "./tools/neutron-bun.sh cli fixRecurringTimezoneDrift",
    "core:test": "jest ./libs/core/test",
    "translation:test": "jest ./libs/translation/test",
    "core:generate:fallback-translations": "bun ./libs/core/src/i18n/generate-fallback-translations.ts"
  },
  "dependencies": {
    "rimraf": "^5.0.10"
  },
  "devDependencies": {
    "@swc/core": "^1.16.18",
    "@swc/jest": "^0.2.39",
    "@types/jest": "^30.0.0",
    "@typescript-eslint/parser": "^8.70.0",
    "@vitejs/plugin-vue": "^6.0.10",
    "@vitest/browser-playwright": "^5.0.5",
    "concurrently": "^10.0.5",
    "eslint": "^10.11.0",
    "eslint-plugin-playwright": "^2.11.0",
    "eslint-plugin-vue": "^10.10.0",
    "eslint-plugin-vuetify": "~2.7.2",
    "husky": "^9.1.7",
    "jest": "^30.5.2",
    "jest-junit": "^17.0.0",
    "jsdom": "^30.1.3",
    "lint-staged": "^17.6.0",
    "oxfmt": "^0.72.0",
    "oxlint": "^1.87.0",
    "playwright": "1.64.1",
    "typescript": "^6.0.3",
    "vitest": "^5.0.5"
  },
  "overrides": {
    "@nestjs/common": {
      "version": "^10.3.10"
    },
    "@nestjs/core": {
      "version": "^10.3.10",
      "nestjs-ddtrace": "^5.0.0"
    },
    "@nestjs/platform-express": {
      "version": "^10.3.10",
      "path-to-regexp": "^0.1.13"
    },
    "@nestjs/swagger": "^7.4.0",
    "@node-saml/node-saml": "^5.1.0",
    "axios": "^1.20.0",
    "body-parser": "^1.20.9",
    "brace-expansion@<1.1.12": "^1.1.21",
    "ckeditor5": "44.3.0",
    "express": "^4.22.3",
    "fake-smtp-server": {
      "nodemailer": "^7.0.11",
      "mailparser": "^3.14.1"
    },
    "follow-redirects": "^1.16.2",
    "glob": "^10.5.0",
    "js-yaml": "^4.3.2",
    "jws": "^4.0.1",
    "lodash": "^4.18.0",
    "multer": "^2.5.0",
    "nest-commander": {
      "version": "~3.19.1"
    },
    "qs": "^6.17.1",
    "send": "^0.19.0",
    "serve-static": "^1.16.0",
    "tmp": "^0.2.7",
    "validator": "^13.15.22",
    "ws": "^8.22.0"
  }
}
